<template>
  <div>
    <div v-if="showHandleIcon" class="teacher-str">
      老师：
      <Tooltip class="teacher-content" max-width="150" :content="teacherStr">
        <span class="single-ellipsi">{{ teacherStr }}</span>
      </Tooltip>
      <Icon
        type="md-add"
        color="#488ffa"
        :size="16"
        @click="handleOpenTeacher"
      ></Icon>
    </div>
    <div v-else>
      <div v-if="selectTeacherListTrue.length > 0" class="data-line">
        <span class="change-btn" @click="handleOpenTeacher">重新选择</span>
      </div>
      <div v-else class="class-add-btn" @click="handleOpenTeacher">
        选择教师
      </div>
      <div v-if="selectTeacherListTrue.length > 0">
        <Table
          ref="teacherTable"
          :width="800"
          border
          :columns="teacherColumn"
          :data="selectTeacherListTrue"
        ></Table>
      </div>
    </div>
    <Modal
      v-model="modalShow"
      :width="800"
      title="选择教师"
      :footer-hide="true"
      :closable="false"
      @on-visible-change="getModalChange"
    >
      <div class="search-line">
        <Input
          v-model="teacherName"
          class="search-input"
          placeholder="请输入教师名称"
        ></Input>
        <Button type="primary" @click="handleSearch">搜索</Button>
        <Button @click="handleReset">重置</Button>
      </div>
      <div class="search-type">
        <Button
          :type="selectType === 1 ? 'primary' : 'default'"
          @click="changeType(1)"
        >
          学校
        </Button>
        <Button
          v-if="applyId != schoolId"
          :type="selectType === 2 ? 'primary' : 'default'"
          @click="changeType(2)"
        >
          提供方
        </Button>
      </div>
      <RadioOrCheckboxTable
        v-model="selectTeacherList"
        :table-column="teacherColumn"
        :table-data="teacherList"
        :table-total="teacherPageInfo.total"
        :table-current="teacherPageInfo.pageNum"
        :select-type="2"
        :table-loading="tableLoading"
        @pageChange="getPageChange"
      ></RadioOrCheckboxTable>
      <div class="modal-footer">
        <Button @click="handleCancleBtn">取消</Button>
        <Button type="primary" @click="handleSureBtn">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import courseCenterApi from '@/request/courseCenter/courseCenterApi.js';
import RadioOrCheckboxTable from '@c/Base/RadioOrCheckboxTable.vue';
export default {
  name: 'ChooseTeacherForForm',
  /**
   * 组件暴露的方法
   * postTeacherData : 选择的教师数据
  */
  components: {
    RadioOrCheckboxTable
  },
  props: {
    schoolId: {
      type: String,
      default: ''
    },
    // 课程id
    applyId: {
      type: String,
      default: ''
    },
    // 从父组件传过来的教师列表
    parentTeacherList: {
      type: Array,
      default: () => []
    },
    showHandleIcon: {
      type: Boolean,
      default: false
    } // 添加教师是否用图标展示
  },
  data() {
    return {
      tableLoading: false,
      selectTeacherList: [], // 选择的教师列表(跟随列表变动)
      selectTeacherListTrue: [], // 点击确定之后出现的教师列表
      selectType: 1, //
      teacherColumn: [
        {
          title: '教师名称',
          key: 'userName',
          minWidth: 200
        }, {
          title: '手机号码',
          key: 'phoneNo',
          width: 180
        }, {
          title: '提供方',
          key: 'orgName',
          minWidth: 200
        }
      ], // 教师列表表格column
      teacherList: [], // 教师数据列表
      teacherPageInfo: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      },
      teacherName: '', // 教师姓名
      selectApply: '', // 请选择单位
      selectSchoolArea: '', // 选择的校区
      modalShow: false
    };
  },
  computed: {
    teacherStr() {
      let str = '';
      if (this.selectTeacherListTrue.length === 0) {
        return str;
      }
      this.selectTeacherListTrue.forEach((item, index) => {
        str += item.userName;
        if (index < this.selectTeacherListTrue.length - 1) {
          str += ',';
        }
      });
      return str;
    }
  },
  watch: {
    parentTeacherList: {
      handler(newVal, oldVal) {
        console.log('更新了数据-----', newVal);
        this.dealTeacherList(JSON.parse(JSON.stringify(newVal)));
      },
      deep: true
    },
    applyId(newVal, oldVal) {
      console.log(newVal, oldVal, '数据变化了吗----');
      if (oldVal) {
        this.selectTeacherList = [];
        this.selectTeacherListTrue = [];
      }
    }
  },
  created() {
    this.dealTeacherList(this.parentTeacherList);
  },
  methods: {
    // 点击取消按钮
    handleCancleBtn() {
      this.modalShow = false;
    },
    dealTeacherList(list) {
      this.selectTeacherList = list.map(item => {
        const obj = {
          userId: item.teacherId,
          userName: item.teacherName,
          orgName: item.orgName,
          schoolId: item.schoolId,
          phoneNo: item.phoneNo ? item.phoneNo : ''
        };
        return obj;
      });
      // this.getSelectTeacherData();
      this.selectTeacherListTrue = JSON.parse(JSON.stringify(this.selectTeacherList));
      console.log(this.selectTeacherList, this.selectTeacherListTrue, '选择教师列表-------');
    },
    changeType(type) {
      this.selectType = type;
      this.teacherPageInfo = {
        total: 0,
        pageSize: 10,
        pageNum: 1
      };
      this.selectTeacherList = this.selectTeacherListTrue.filter(item => {
        console.log(item, '拿到的------', this.selectType === 2 ? this.applyId : this.schoolId);
        return item.schoolId === (this.selectType === 2 ? this.applyId : this.schoolId); // 学校id
      });
      this.getTeacherListData();
    },
    // 选择老师弹窗打开
    handleOpenTeacher() {
      this.teacherName = '';
      if (this.schoolId === '') {
        return this.$Message.error('请先选择学校！');
      }
      if (this.applyId === '') {
        return this.$Message.error('请先选择课程商品！');
      }
      this.teacherPageInfo = {
        total: 0,
        pageSize: 10,
        pageNum: 1
      };
      this.selectType = 1;
      this.selectTeacherList = this.selectTeacherListTrue.filter(item => {
        return item.schoolId === (this.selectType === 2 ? this.applyId : this.schoolId); // 学校id
      });
      console.log('选择的教师列表----', this.selectTeacherList);
      this.getTeacherListData();
      this.modalShow = true;
    },
    getPageChange(page) {
      this.teacherPageInfo.pageNum = page;
      this.getTeacherListData();
    },
    handleSearch() {
      this.teacherPageInfo.pageNum = 1;
      this.teacherPageInfo.total = 0;
      this.getTeacherListData();
    },
    handleReset() {
      this.teacherName = '';
      this.handleSearch();
    },
    // 获取教师列表
    async getTeacherListData() {
      const params = {
        orgId: this.selectType === 2 ? this.applyId : this.schoolId, // 学校id
        pageNum: this.teacherPageInfo.pageNum,
        pageSize: this.teacherPageInfo.pageSize
      };
      if (this.teacherName) {
        params.userName = this.teacherName;
      }
      this.tableLoading = true;
      const res = await courseCenterApi.serachTeachers(params);
      this.tableLoading = false;
      if (res.status === 200) {
        this.teacherList = res.message.list.map(item => {
          item.schoolId = params.orgId;
          return item;
        });
        this.teacherPageInfo.total = Number(res.message.total);
      }
    },
    // 获取选择的教师列表
    handleSureBtn() {
      this.selectTeacherListTrue = JSON.parse(JSON.stringify(this.selectTeacherList));
      this.$emit('postTeacherData', this.selectTeacherListTrue);
      this.modalShow = false;
    },
    getModalChange(status) {
      if (!status) {
        this.selectTeacherList = [];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.search-line {
  margin-bottom: 16px;
  .search-input {
    width: 180px;
    margin-right: 16px;
  }
  button + button {
    margin-left: 16px;
  }
}
.change-btn {
  cursor: pointer;
}
.search-type {
  margin-bottom: 16px;
  button + button {
    margin-left: 16px;
  }
}
.teacher-str {
  display: flex;
  align-items: center;
  .teacher-content {
    flex: 1;
  }
  .single-ellipsi {
    width: 100%;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
}
.modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  button + button {
    margin-left: 8px;
  }
}
</style>
